import VConsole from 'vconsole'
let vConsole = new VConsole()
export default vConsole